module.exports = __webpack_public_path__ + "img/scandisini.c671cd7e.png";